import React from 'react';
import styled from 'styled-components';
//
import { TCompareBoxPlotProps } from 'pages/compare/box-plot';
import BoxPlot from 'components/visuals/box-plot/box-plot';
import { Control, ControlGroup, Controls } from 'components/visuals/_common';
import MultiToggleButton from 'components/buttons/multi-toggle';
import { EDisplay } from 'components/deal-results/product-items';
import { getActiveIndexForMultiToggleButton } from 'components/deal-results/product-items/helpers';

const Container = styled.div`
  padding: 8px 32px;
`;

const CompareBoxPlot = ({
  lineGraphItems,
  legendText,
  selectedDisplay,
  pricePerUnitLabel,
  setSelectedDisplay,
}: TCompareBoxPlotProps) => {
  const multiToggleButtonOptions = [
    { text: 'Base', onClick: () => setSelectedDisplay(EDisplay.BASE) },
    { text: 'Revenue', onClick: () => setSelectedDisplay(EDisplay.SALES) },
    { text: 'Netback', onClick: () => setSelectedDisplay(EDisplay.NETBACK) },
    { text: 'Margin', onClick: () => setSelectedDisplay(EDisplay.MARGIN) },
  ];

  return (
    <Container>
      <Controls>
        <ControlGroup>
          <Control>
            <MultiToggleButton
              label="DISPLAY"
              indexActive={getActiveIndexForMultiToggleButton(selectedDisplay)}
              options={multiToggleButtonOptions}
            />
          </Control>
        </ControlGroup>
      </Controls>

      <BoxPlot
        lineGraphItems={lineGraphItems}
        legendText={legendText}
        selectedDisplay={selectedDisplay}
        pricePerUnitLabel={pricePerUnitLabel}
        productItemId="0"
      />
    </Container>
  );
};

export default CompareBoxPlot;
